<template>
    <div class="powerConsumption"  :class="{'cn':version == '1'}">
      <div class="powerConsumption_box">
        <div class="powerConsumption_title">
          <div class="select1" >
            <div class="select_lm1" :class="profileSelectShow ? 'select' : ''">
              <div class="val_box1" @click="profileSelectFun" >
                <div class="val" >{{ operaTypeStr }}</div>
                <div class="icon_x"></div>
              </div>
              <div class="select_xl_lm_bg" v-if="profileSelectShow" @click="profileSelectFun"></div>
              <div class="select_xl_lm" v-if="profileSelectShow">
                <div class="icon"></div>

                <div class="ul scrollbar_style">
                  <div class="li" v-for="(item, index) in dateTypeArr" :key="index"
                    @click="dateTypeChange(item)" >
                    <div class="text">{{ item.name }}</div>
                    <!-- <div class="selectDrop" :class="lightControlForm.sceneIds.indexOf(item.id) != -1 ? 'select': ''">
                      <div class="drop"></div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="upload" @click="imageDownload()" v-loading = "loading.exportExcel" style="cursor: pointer;">
            <!-- <img style="width: 2.55rem" src="../img/icon/download_icon.png" > -->
            <div class="img"></div>
          </div>
        </div>
        <div class="powerConsumption_body">
          
          <div class="echarts_line" style="width: 78rem; height: 40rem" id="main" v-loading="loading.consumption"></div>
          
        </div>
      </div>
    </div>
  </template>
  
  <script type="text/javascript">
  import { mapGetters } from "vuex";
  import allUrl from '../api/allUrl.js'
  import base from '../api/base.js'
  // import echarts from 'echarts';


  export default {
    name: "home",
    data() {
      return {
        profileSelectShow: false,
        // dateTypeName:'',
        operaTypeStr:'',
        operaTypeId:'3',
        activeNames: ["1"],
        handleCommand: "",
        index: 1,
        editShow: false,
        editShow1: false,
        editShow2: false,
        editShow3: false,
        editShow4: false,
        editShow5: false,
  
        sceneIndex: null,
        sceneList: [],
        subSceneList: [],

        echarts_line: null,

        dateTypeArr:[],
  
        charts: "",

        protocolStr: '',
        domainName:'',

        loading: {
          sceneApplying: false,
          consumption: false,
          exportExcel:false
        },
        // opinionData: ["5", "3", "6", "5", "5", "6", "6", "7", "5","7"]
      }
    },
    computed: {
      ...mapGetters({

        token: "token",
        client_key: "client_key",
        username: "username",
        version: "version",
  
        projectId: 'projectId',
  
        remRatio: "remRatio",
        updateRemRatio: "updateRemRatio",
  
        countryId: "countryId",
        provinceId: "provinceId",
        cityId: "cityId",
        hotelId: "hotelId",
        headerIdStr: "headerIdStr",
        themeType: 'themeType',
      }),
      // sensorFormModelName(){
      //     let name = '';
      //     for(let d of this.modelNav){
      //         if(d.id == this.sensorForm.model){
      //             name = d.name
      //         }
      //     }
      //     return name
      // }
    },
    components: {
      // 'sideBar':sideBar
    },
    beforeDestroy() { },
    mounted() {
      this.protocolStr = document.location.protocol;
      this.domainName = window.location.href.split("/")[2];
      if(this.domainName == 'localhost:8080' || this.domainName == '127.0.0.1:8080'|| this.domainName == '10.0.0.94:8080'){
          this.domainName = 'lighting.lampmind.com'
      }
      // this.sceneListGet();

      this.consumptionStatisticsGet();

      // this.$nextTick(function () {
      //   this.echartsLineFun("main");
      // });
      
      this.dateTypeArr = [
        { id: "0", name: this.$t("App.powerConsumption.text1") },
        { id: "1", name: this.$t("App.powerConsumption.text2") },
        { id: "2", name: this.$t("App.powerConsumption.text3") },
        { id: "3", name: this.$t("App.powerConsumption.text4") },
      ];

      for(let d of this.dateTypeArr){
        if(d.id == this.operaTypeId){
          this.operaTypeStr = d.name;
        }
        // console.log(d.name,d.id,'8484---')
      }
      // this.dateTypeName = this.dateTypeArr[0].name
      // console.log(this.dateTypeName,this.operaTypeStr,'--1--111')

    },
    methods: {
      skinClassFun(){
      let obj = {};
      obj['cn'] = this.version == '1';
      // obj['ratio_1920_1080'] = this.ratio == '1';
      if(this.themeType == 1){
        obj['themeType_' + 1] = true;
      }
      // obj['themeType_' + 1] = true;
      return obj
    },
      profileSelectFun() {
        if (this.profileSelectShow) {
          this.profileSelectShow = false;
        } else {
          this.profileSelectShow = true;
        }
      },

      dateTypeChange(data) {
        this.operaTypeStr = data.name;
        this.operaTypeId = data.id;
        
        // let d = ''
        // if(this.operaTypeId == 0){
        //   let OnTime = new Date();
        //   OnTime =  OnTime.getFullYear()+'-'+(OnTime.getMonth() + 1)+'-'+ OnTime.getDate()
        //   console.log(OnTime)
        // }
          this.consumptionStatisticsGet();
          this.profileSelectShow = false;
      },
      //下载图表
      imageDownload(){
        if(this.loading.exportExcel){
          return
        }
        this.loading.exportExcel = true;
        base.ajax_post(
          allUrl.project.project_consumptionStatistics,
          {
            username: this.username,
            version: this.version,
            token: this.token,
            clientType: this.os,
            projectId: this.projectId,
            dateType: this.operaTypeId,
            download: 1,
          },
          {},
          data => {
            this.loading.exportExcel = false;
            base.download(this.protocolStr+'//'+this.domainName+'/'+data.data.path);
          },
          this,()=>{
            this.loading.exportExcel = false;
          })
        // var img = new Image();
        // img.src = this.echarts_line.getDataURL({
        //   type:"png",
        //     pixelRatio: 2,
        //     backgroundColor: '#fff'
        // });
        // img.onload =function(){
        //   var canvas =document.createElement("canvas");
        //   canvas.width = img.width;
        //   canvas.height = img.height;
        //   var ctx = canvas.getContext("2d");
        //   ctx.drawImage(img, 0, 0);
        //   var dataURL = canvas.toDataURL("image/png");
        //   var a= document.createElement("a");
        //   var event = new MouseEvent("click");
        //   a.download ="图片.png"||"下载图片名称";
        //   //将生成的URL设置为a.href属性
        //   a.href = dataURL;
        //   // 触发a的单击事件
        //   a.dispatchEvent(event);
        //   a.remove();
        // }
      },
      // 耗电量统计
      consumptionStatisticsGet() {
        if (this.loading.consumption) {
        return
      }
        this.loading.consumption = true;
        base.ajax_post(
          allUrl.project.project_consumptionStatistics,
          {
            username: this.username,
            version: this.version,
            token: this.token,
            clientType: this.os,
            projectId: this.projectId,
            dateType: this.operaTypeId,
          },
          {},
          data => {
            // console.log(data.data,'--111-55-55')
            // console.log(data);
            // if(this.operaTypeId == 0){
            //   for(let key in data.data.timeList){
            //     data.data.timeList[key] = data.data.timeList[key].split(' ')[1]
            //   }
            // }
            let dataListMax = 0;
            let gridLeft = 0;
            for (let key in data.data.dataList) {
              // data.data.dataList[key] = parseInt(data.data.dataList[key]+100);
              if (data.data.dataList[key] > dataListMax) {
                dataListMax = data.data.dataList[key];
              }
            }
            console.log(data.data.dataList)
            // let titleText = '';
            dataListMax = dataListMax + '0'
            
            if(this.operaTypeId == 0){
              dataListMax = dataListMax + '00'
            }
            let color = 'rgba(58, 99, 111, 1)'
            let color1 = {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0, color: 'rgba(66, 144, 217, 1)' // 0% 处的颜色
              }, {
                offset: 1, color: 'rgba(217, 237, 255, 1)' // 100% 处的颜色
              }],
              global: false // 缺省为 false
            }
            if(this.themeType ==1){
              color = '#682411';
              color1 = '#fe5e08';
            }
            if(this.themeType ==2){
              color = '#2e2e2e';
              color1 = '#2e2e2e';
            }
            console.log(dataListMax,'---1-1-1-')
            gridLeft = (dataListMax.length * 0.8+1) * this.remRatio;
            this.$nextTick(function () {
              if (document.getElementsByClassName('echarts_line')[0]) {
                this.$echarts.dispose(document.getElementsByClassName('echarts_line')[0])
                // this.lampLightEcharts.clear();
                this.echarts_line = this.$echarts.init(document.getElementsByClassName('echarts_line')[0]);
                let option = {
                  title: {
                    left: 'center',
                    // text: this.$t('App.calendar.month3')+'.2023-'+this.$t('App.calendar.month3')+'.2024',
                  },
                  grid: {
                    top: 3 * this.remRatio,
                    left: gridLeft,
                    bottom: 2 * this.remRatio,
                    right: 2.5 * this.remRatio,
                    // right: '2%',
                  },
                  xAxis: {
                    data: data.data.timeList,
                    type: 'category',
                    // boundaryGap: false,
                    // x轴字体
                    axisLabel: {
                      color: color,
                      fontSize: '12',
                      fontWeight: 500,
                      // fontFamily: Calibri,
                      // fontWeight: normal,
                    },
                  },
                  yAxis: {
                    name: 'kW·h',
                    type: 'value',
                    // nameGap: 10,
                    axisLabel: {
                      color: color,
                      fontSize: '12',
                      // fontFamily: Calibri,
                      fontWeight: 500,
                      // fontWeight: normal,
                    },
                    // axisTick: {
                    //   show: true
                    // },
                    // 数轴
                    axisLine: {
                      // show: true,
                      lineStyle: {
                        color: color,
                      }
                    },
                    // // 刻度
                    // splitNumber: 7,
                    splitLine: {
                      // show: false,
                      lineStyle: {
                      type: 'dashed',
                        color: color,
                      }
                    }
                  },
                  series: [
                    {
                      data: data.data.dataList,
                      type: 'bar',
                      name: 'power',
                      itemStyle: {
                        // color: '#6a8ddd',
                        opacity: 0.6,
                        color: color1
                      },
                    },
                  ]
                };
                this.echarts_line.setOption(option);
              }
            })
            this.loading.consumption = false;
          },
          this, () => { })
      },
      handleChange(val) {
        console.log(val);
      },
      
      itemFun(index) {
        console.log(this.sceneIndex, index)
        if (this.sceneIndex == index) {
          this.sceneIndex = ''
        } else {
          this.sceneIndex = index;
        }
      },
      editShowFun(item) {
        item.editShow = item.editShow ? false : true
      },
      edit() {
        this.$router.replace("edit_sceneSetting.vue");
      },
      // linkToFun(val,data){
      // }
  
      sceneApply(obj) {
        if (obj.sceneApplying) {
          return
        }
        obj.sceneApplying = true;
        base.ajax_post(
          allUrl.scene.scene_apply,
          {
            username: this.username,
            version: this.version,
            token: this.token,
            id: obj.id,
          },
          {},
          data => {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'success'
            });
  
            obj.sceneApplying = false;
            this.sceneListGet();
          },
          this, () => {
            obj.sceneApplying = false;
          })
      },
      clickStop() {
  
      },
      // 情景列表
      sceneListGet() {
        console.log(this.formReportQuestion)
        // baseApi.ajax_post(
        base.ajax_post(
          allUrl.scene.scene_list,
          {
            username: this.username,
            version: this.version,
            token: this.token,
            clientType: this.os,
  
            projectId: this.projectId,
          },
          {},
          data => {
            let sceneList = []
            for (let d of data.data.list) {
              d.editShow = false
              d.sceneApplying = false
              d.subHeight = d.subSceneList.length;
              // console.log(d.subSceneList)
              sceneList.push(d)
            }
            this.$set(this,'sceneList',sceneList)
            // } else {
            //   this.$message({
            //     showClose: true,
            //     message: data.msg,
            //     type: 'success'
            //   });
            // }
          },
          this, () => { })
      },

      
    },

    watch: {
      projectId: function () {
        this.sceneListGet();
      },
      updateRemRatio: function () {
        this.$nextTick(function () {
        //   console.log(this.lampPolePowerEcharts)
          if (this.echarts_line) {
            this.echarts_line.resize();
          }
        })
      }
    },
  
  };
  </script>
  
  <style type="text/css" lang="less">
  .powerConsumption {
    position: absolute;
    z-index: 1;
    left: 0;
    width: 100%;
    min-height: 50rem;
    margin: 0 auto;
    overflow: hidden;
    // position: relative;
    display: flex;
    background: rgba(255, 255, 255, 0.85);
    justify-content: center;
    align-items: center;
    top: 5.78rem;
    height: calc(100% - 5.78rem);
    
    .powerConsumption_box {
      width: 78.95rem;
      // height: 36.71rem;
      height: 53.75rem;

      // opacity: 0.9;
      // display: block;
      margin-top: 6.18rem;
      .powerConsumption_title {
        display: flex;
        .el-select {
          // border-radius: 0.33rem;
          // border: 0px solid #3A636F;
          width: 12.76rem;
          height: 2.5rem;
          .el-input__inner {
            // width: 12.76rem;
            // height: 2.5rem;
            border-radius: 0.33rem;
            border: 1px solid #3A636F;
            font-family: Calibri;
            font-weight: normal;
            font-size: 1.8rem;
            color: #3A636F;
            background-color: transparent;
          }
          .el-select__caret {
            color: #3A636F;
            font-size: 1.8rem;
          }
          .el-select-dropdown {
            opacity: 0.9;
            border: 1px solid #3A636F;
          }
          .el-select-dropdown__item .selected {
            color: #3A636F;
            background-color: aliceblue;
            font-weight: 500;
          }
          .el-select-dropdown__item {
            font-family: Calibri;
            font-weight: normal;
            font-size: 1.8rem;
            // color: #3A6373;
          }
          .el-popper[x-placement^=bottom] .popper__arrow {
            left: 171px;
            border-bottom-color: #3A636F;
          }
        }

        .sport {
          margin-left: 1.84rem;
          border-radius: 0.33rem;
          border: 0px solid #3A636F;
        }
        .upload {
          // width: 3.55rem;
          // height: 3.55rem;
          margin-left: auto;
          .img {
            width: 2.55rem;
            height: 2.25rem;
            background-image: url("../img/icon/download_icon.png");
            background-size: 100% 100%;
            background-position: center;
          }
        }
        .select1 {
          position: relative;
          .select_lm1 {
            margin-left: 2.24rem;
            position: absolute;
            width: 13.76rem;
            height: 2.5rem;
            top: 0;
            &.multiple {
              .li {
                display: flex;
                justify-content: space-between;
                align-items: center;
              }

              .selectDrop {
                margin-left: 1rem;
                width: 1.2rem;
                height: 1.2rem;
                border-radius: 50%;
                border: 0.15rem solid #00c6ff;
                display: flex;
                align-items: center;
                justify-content: center;
                visibility: hidden;

                &.select {
                  visibility: initial;
                }

                .drop {
                  width: 0.55rem;
                  height: 0.55rem;
                  background: #00c6ff;
                  border-radius: 50%;
                }
              }
            }

            &.select {
              .val_box1 {
                .icon_x {
                  transform: rotateZ(90deg);
                }
              }
            }

            .val_box1 {
              width: 13.76rem;
              height: 2.5rem;
              line-height: 2.5rem;
              padding-left: 1.32rem;
              padding-right: 5.46rem;
              cursor: pointer;
              display: flex;
              // align-items: center;
              justify-content: space-between;
              white-space:nowrap;

              border-radius: 0.33rem;
              border: 1px solid #3A636F;
              font-family: Calibri;
              font-weight: normal;
              font-size: 1.8rem;
              color: #3A636F;
              background-color: transparent;
              .i {
                top: 0.3rem;
                left: -1.5rem;
                position: absolute;
                margin-right: 0.5rem;
                color: #ff0101;
              }
              .img {
                width: 2.43rem;
                height: 2.24rem;
              }

              .val {
                font-family: Calibri;
                font-weight: normal;
                font-size: 1.8rem;
                color: #3a636f;
                margin-right: 0.5rem;
                // overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }

              .icon_x {
                // transition: all 0.5s;
                position: absolute;
                top: 0.5rem;
                right: 0.25rem;
                width: 1.84rem;
                height: 1.84rem;
                transform: rotateZ(90deg);
                background-image: url("../img/icon/rightArrow.png");
                background-position: center;
                background-size: 100% 100%;
              }
            }

            .select_xl_lm_bg {
              position: fixed;
              top: 0;
              right: 0;
              left: 0;
              bottom: 0;
            }

            .select_xl_lm {
              position: absolute;
              left: 0.01rem;
              top: 3.2rem;
              border: 0.1rem solid #3a636f;
              z-index: 1;
              background: #f4fbfd;

              width: 13.83rem;
              height: 10.33rem;
              background: #F4FBFD;
              border-radius: 0.33rem;
              opacity: 0.9;
              .ul {
                background: #f4fbfd;
                border-radius: 1rem;
                position: relative;
                z-index: 1;
                max-height: 20rem;
                margin: 0 0.5rem;
              }

              .icon {
                position: absolute;
                // right: 1.2rem;
                // left: 10.8rem;
                left: 12rem;
                top: -0.5rem;
                width: 1rem;
                height: 1rem;
                background: #f4fbfd;
                border-top: 0.1rem solid #3a636f;
                border-left: 0.1rem solid #3a636f;
                // border-radius: 0.1rem;
                transform: rotateZ(45deg);
              }

              .li {
                padding-left: 1.25rem;
                padding-right: 1rem;
                height: 2.5rem;
                line-height: 2.5rem;
                font-family: Calibri;
                font-weight: normal;
                font-size: 1.8rem;
                color: #3a636f;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .edit {
                  margin-left: 1rem;
                  visibility: hidden;
                  display: inline-block;
                  width: 1.5rem;
                  height: 1.5rem;
                  background-image: url("../img/icon/edit.png");
                  background-size: 100%;
                  background-position: center;
                }
                &:hover {
                  background: #e3f9ff;
                  .edit {
                    visibility: initial;
                  }
                }
                .text {
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
              }
            }
          }

          &.margin_b {
            margin-bottom: 4.5rem;
          }
          // width: 32.54rem;
          // height: 4.12rem;
          // border: 0.09rem solid #3A636F;
          // border-radius: 0.44rem;
          // margin: 2.02rem 0 0 3.77rem;
          
          .span {
            margin-top: -0.2rem;
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3a636f;
            position: relative;
            top: -0.2rem;
          }
        }
      }
      .powerConsumption_body {
        background: rgba(244, 251, 253, 0.9);
        // height: 47.04rem;
        height: calc(100% - 12.89rem);
        margin-top: 2.89rem;
        .echarts_line {
          position: absolute;
          margin-top: 1rem;
        }
      }
    }
  }
  .el-select__caret {
    color: #3A636F;
    font-size: 1.8rem;
  }
  .el-select-dropdown {
    opacity: 0.9;
    border: 1px solid #3A636F;
  }
  .el-select-dropdown__item .selected {
    color: #3A636F;
    background-color: aliceblue;
    font-weight: 500;
  }
  .el-select-dropdown__item {
    font-family: Calibri;
    font-weight: normal;
    font-size: 1.8rem;
    // color: #3A6373;
  }
  .el-popper[x-placement^=bottom] .popper__arrow {
    left: 171px;
    border-bottom-color: #3A636F;
  }
  .el-select-dropdown__item.selected {
      color: #3A636F;
      font-weight: 500;
      background-color: #E3F9FF;
  }
  .el-select-dropdown__list {
    padding: 1px 0;
  }
  // .powerConsumption.themeType_1 {
  //   background: rgba(250,  237, 218, 0.85);
  //   .powerConsumption_box {
  //     .powerConsumption_title {
  //       .el-select {
  //         .el-input__inner {
  //           border: 1px solid #682411;
  //           color: #682411;
  //         }
  //         .el-select__caret {
  //           color: #682411;
  //         }
  //         .el-select-dropdown {
  //           opacity: 0.9;
  //           border: 1px solid #682411;
  //         }
  //         .el-select-dropdown__item .selected {
  //           color: #682411;
  //           background-color: aliceblue;
  //         }
  //         .el-popper[x-placement^=bottom] .popper__arrow {
  //           left: 171px;
  //           border-bottom-color: #682411;
  //         }
  //       }

  //       .sport {
  //         margin-left: 1.84rem;
  //         border-radius: 0.33rem;
  //         border: 0px solid #682411;
  //       }
  //       .upload {
  //         .img {
  //           background-image: url("../img/orange/download_icon.png");
  //         }
  //       }
  //       .select1 {
  //         .select_lm1 {
  //           .val_box1 {
  //             border: 1px solid #682411;
  //             color: #682411;
  //             .i {
  //               color: #ff0101;
  //             }
  //             .val {
  //               color: #682411;
  //             }
  //             .icon_x {
  //               top: 0.6rem;
  //               right: 0.8rem;
  //               width: 1rem;
  //               height: 1.5rem;
  //               background-image: url("../img/orange/rightArrow.png");
  //             }
  //           }
  //           .select_xl_lm {
  //             border: 0.1rem solid #682411;
  //             background: #faedda;
  //             .ul {
  //               background: #faedda;
  //             }
  //             .icon {
  //               background: #faedda;
  //               border-top: 0.1rem solid #682411;
  //               border-left: 0.1rem solid #682411;
  //             }

  //             .li {
  //               color: #682411;
  //               // .edit {
  //               //   background-image: url("../img/icon/edit.png");
  //               // }
  //               &:hover {
  //                 background: #fdbe6e;
  //               }
  //             }
  //           }
  //         }
  //         .span {
  //           color: #682411;
  //         }
  //       }
  //     }
  //     .powerConsumption_body {
  //       // background: rgba(244, 251, 253, 0.9);
  //       background: rgba(250, 237, 218, 1);
  //       .echarts_line {
  //         position: absolute;
  //         margin-top: 1rem;
  //       }
  //     }
  //   }
  //   .el-select__caret {
  //     color: #682411;
  //     font-size: 1.64rem;
  //   }
  //   .el-select-dropdown {
  //     opacity: 0.9;
  //     border: 1px solid #682411;
  //   }
  //   .el-select-dropdown__item .selected {
  //     color: #682411;
  //     background-color: aliceblue;
  //     font-weight: 500;
  //   }
  //   .el-popper[x-placement^=bottom] .popper__arrow {
  //     left: 171px;
  //     border-bottom-color: #682411;
  //   }
  //   .el-select-dropdown__item.selected {
  //       color: #682411;
  //       font-weight: 500;
  //       background-color: #682411;
  //   }
  //   .scrollbar_style::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
  //       border-radius: 0.5rem;
  //       // background: #DAE6E0;
  //       background: #682411;
  //   }
  //   .scrollbar_style::-webkit-scrollbar-track {/*滚动条里面轨道*/
  //       background: #faedda;
  //   }
  // }
  </style>